module.exports = __webpack_public_path__ + "img/mei.18064ea5.jpg";